import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Drupal is an enterprise-grade open-source CMS built for complex content models, granular permissions and high traffic. It's the right choice when a site needs serious structure behind the scenes.",
    "We build and migrate Drupal sites with clean content architecture, custom modules and careful attention to security and performance — so large, multi-author sites stay fast and manageable.",
];

const FEATURES = [
    { title: "Structured content", text: "Model complex content types and relationships without hitting a wall." },
    { title: "Granular permissions", text: "Fine-grained roles and workflows suit large teams and editorial processes." },
    { title: "Custom module development", text: "Extend Drupal with bespoke functionality tailored to your needs." },
    { title: "Secure & scalable", text: "A hardened platform that holds up under traffic and audit alike." },
];

const CHECKS = [
    "Drupal site development",
    "Custom module development",
    "Theme development",
    "Version migration & upgrades",
    "Maintenance & support",
];

export default function Drupal() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="CMS & Migration" title="Drupal Development" eyebrowAs="span">
                    Robust, secure Drupal builds for content-rich sites that need structure, permissions and scale.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
